import IconSvg from 'core/_legacy/icons/IconSvg'

const JCBLogo = () => (
  <IconSvg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="#555"
  >
    <g id="surface1">
      <path
        d="M 45 35 C 45 37.210938 43.210938 39 41 39 L 7 39 C 4.789063 39 3 37.210938 3 35 L 3 13 C 3 10.789063 4.789063 9 7 9 L 41 9 C 43.210938 9 45 10.789063 45 13 Z"
        fill="#cfd8dc"
      />
      <path
        d="M 10.667969 13 C 8.578125 13 7 14.324219 7 16.617188 L 7 35 L 13.484375 35 C 15.113281 35 17 33.46875 17 31.484375 L 17 13 Z"
        fill="#3f51b5"
      />
      <path
        d="M 22.667969 13 C 20.578125 13 19 14.324219 19 16.617188 L 19 35 L 25.484375 35 C 27.113281 35 29 33.46875 29 31.484375 L 29 13 Z"
        fill="#e53935"
      />
      <path
        d="M 34.667969 13 C 32.578125 13 31 14.324219 31 16.617188 L 31 35 L 37.484375 35 C 39.113281 35 41 33.46875 41 31.484375 L 41 13 Z"
        fill="#388e3c"
      />
      <path
        d="M 15.804688 24.453125 C 15.804688 26.289063 13.4375 27.257813 11.703125 27.257813 C 9.820313 27.257813 8.136719 26.136719 7.777344 24.710938 L 9.054688 24.710938 C 9.203125 25.578125 10.074219 26.1875 11.039063 26.1875 C 12.109375 26.1875 12.875 25.421875 12.875 24.453125 L 12.875 21.144531 L 15.804688 21.144531 Z"
        fill="#fafafa"
      />
      <path
        d="M 38.605469 24.039063 C 39.367188 24.039063 39.902344 23.277344 39.902344 22.519531 C 39.902344 21.757813 39.238281 21.097656 38.476563 21.097656 L 32.214844 21.097656 L 32.214844 26.949219 L 38.605469 26.949219 C 39.46875 26.949219 40.128906 26.191406 40.128906 25.429688 C 40.128906 24.671875 39.46875 24.039063 38.605469 24.039063 Z M 34.652344 21.707031 L 36.628906 21.707031 C 37.132813 21.707031 37.589844 22.160156 37.589844 22.664063 C 37.589844 23.175781 37.132813 23.632813 36.628906 23.632813 L 34.652344 23.632813 Z M 36.679688 26.34375 L 34.652344 26.34375 L 34.652344 24.414063 L 36.679688 24.414063 C 37.1875 24.414063 37.644531 24.871094 37.644531 25.378906 C 37.644531 25.886719 37.1875 26.34375 36.679688 26.34375 Z"
        fill="#fafafa"
      />
      <path
        d="M 27.8125 22.175781 C 26.644531 21.90625 25.523438 21.75 24.964844 21.75 C 23.746094 21.75 22.785156 22.765625 22.785156 24.050781 C 22.785156 25.34375 23.746094 26.363281 24.964844 26.363281 C 25.523438 26.363281 26.644531 26.257813 27.8125 25.984375 L 27.8125 27.003906 L 22.9375 27.003906 C 21.414063 27.003906 20.144531 25.660156 20.144531 24.050781 C 20.144531 22.445313 21.414063 21.105469 22.9375 21.105469 L 27.8125 21.105469 Z"
        fill="#fafafa"
      />
    </g>
  </IconSvg>
)

export default JCBLogo
